import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPaginaMdfe from '../../actions/mdfe/alterarRegistrosPorPaginaMdfe'
import determinarPaginaAtualMdfe from '../../actions/mdfe/determinarPaginaAtualMdfe'

export class PaginacaoMdfe extends Component {
  render() {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtualMdfe}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPaginaMdfe}/>
  }
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPaginaMdfe,
    determinarPaginaAtualMdfe
  }, dispatch)
}

export function mapStateToProps(state) {
  return {
    total: state.emissoesMdfe.total,
    paginaAtual: state.paginaAtualMdfe,
    registrosPorPagina: state.registrosPorPaginaMdfe
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoMdfe)
